export default "__VITE_ASSET__5974d1ec__"